// extracted by mini-css-extract-plugin
export default {"container":"AccountDelete_container__dNKUi","forwardButton":"AccountDelete_forwardButton__vkqWb","footer":"AccountDelete_footer__DfFvP","robot":"AccountDelete_robot__aTta9"};